import { render, staticRenderFns } from "./VideosSection.vue?vue&type=template&id=8e6a2a3e&scoped=true"
import script from "./VideosSection.vue?vue&type=script&lang=js"
export * from "./VideosSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6a2a3e",
  null
  
)

export default component.exports